import React from "react";
import Work from "./Work";

const Portfolio = () => {
  return (
    <>
      <div id="portfolio" className="portfolio">
        <h1 className="mainHeading">Portfolio</h1>
        <p className="mainPara">My Recent Work</p>
        <Work/>
      </div>
    </>
  );
};

export default Portfolio;
